var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDeviceError = function SvgDeviceError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 13
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.759 5.244a.843.843 0 0 1 0 1.18L17.239 9l2.52 2.575a.843.843 0 0 1 0 1.18.817.817 0 0 1-1.166 0L16 10.107l-2.593 2.65a.82.82 0 0 1-1.166 0 .843.843 0 0 1 0-1.18l2.52-2.576-2.52-2.575a.843.843 0 0 1 0-1.18.817.817 0 0 1 1.166 0L16 7.895l2.593-2.65a.82.82 0 0 1 1.166 0zM16 0a3 3 0 0 1 3 3v1h-1.5V3A1.5 1.5 0 0 0 16 1.5H5.499v9H11V12H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h13zM3.999 1.5H3A1.5 1.5 0 0 0 1.5 3v6A1.5 1.5 0 0 0 3 10.5h.999v-9z"
  })));
};

export default SvgDeviceError;